import React from "react";
import "./para.css";

export default function Para() {
  return (
    <section className="para">
      <h2 className="parah">Our Heritage Story</h2>
      <p className="parap">
        In 1984, when Pakistan's paint industry was in its infancy, our founder
        had a simple yet powerful vision: to provide Pakistani families with
        high-quality wall paints that combine durability, beauty, and
        affordability. What began as a small family business in Sindh Province
        has evolved into one of Pakistan's most trusted paint brands.
      </p>
    </section>
  );
}
